<template>
  <widget
    :color="color"
    icon="fa fa-headset"
    title="Transfers"
    :value="value"
    :loading="loading"
  />
</template>

<script>
import apiDashboard from '@/apis/dashboard'

import Widget from '@/components/widget/widget8'

export default {
  props: {
    clear: Number,
    refresh: Object,
    from: String,
    to: String,
    direction: String
  },
  components: {
    Widget
  },
  data() {
    return {
      color:
        this.direction === 'outbound'
          ? this.$getVoiceOutboundColor[0]
          : this.$getVoiceColor[0],
      value: 0,
      loading: false
    }
  },
  watch: {
    clear: {
      handler(val) {
        if (val) this.loading = true
      }
    },
    'refresh.count': {
      deep: true,
      immediate: true,
      handler(val) {
        this.getVoiceTransfer()
      }
    }
  },
  methods: {
    async getVoiceTransfer() {
      this.loading = true

      try {
        const obj = {
          from: this.from,
          to: this.to,
          direction: this.direction
        }
        const getVoiceTransfer = await apiDashboard.getVoiceTransfer(obj)
        this.value = getVoiceTransfer.total
      } catch {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
